import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactDOM from 'react-dom'
import { ReactComponent as LimitReminder } from '../../../assets/img/general/limit_reminder.svg';
import './_responsible_gaming_notifications.scss'
import { getReachLimit } from '../../../actions/settings/SettingsAction';
import { LanguageService } from '../../../services/LanguageService';

function ResponsibleGamingNotifications() {
  const reachLimitData = useSelector((state) => state.settings?.reachLimitData);
  const isReachLimitPopupOpen = useSelector((state) => state.settings?.isReachLimitPopupOpen);
  const [counter, setCounter] = useState(15);
  const [isCounterVisible, setIsCounterVisible] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsCounterVisible(counter > 0 ? true : false)
    const timer =
      counter > 0 && isReachLimitPopupOpen && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter,isReachLimitPopupOpen])



  const handlePopupClose = () => {
    dispatch(getReachLimit({ isReachLimitPopupOpen: false }));
    setCounter(15)
  }

  return (
       isReachLimitPopupOpen  ? ReactDOM.createPortal(<div className="tb--modal-lvl1 tb--modal-limitsnotification">
        <div className="tb--modal-lvl2">
          <div className="tb--modal-lvl3 responsible-gaming-notifications_popup">
            <LimitReminder className='responsible-gaming-notifications_popup__image'/>
            <h5 className='responsible-gaming-notifications_popup__title'>{LanguageService.getTranslation('playerLimitNoticeTitle', 'general')}</h5>
            <p className='responsible-gaming-notifications_popup__text'>{reachLimitData.Message}</p>
            <div className='responsible-gaming-notifications_popup__button'>
              <button className={`tb--btn tb--btn-text tb--btn-ternary tb--text_upercase tb--w_100  round-border ${isCounterVisible ? 'disabled' : ''}`} onClick={handlePopupClose}>{LanguageService.getTranslation('gotItButton', 'account')}</button>
              {isCounterVisible ? <span className='count-down'>{counter}</span> : <></>}
            </div>
          </div>
        </div>
      </div>, document.getElementById('modal-root')) : <></>
    )
}

export default ResponsibleGamingNotifications
